import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../../../global.service';
@Component({
  selector: 'app-netflix-questions',
  templateUrl: './netflix-questions.component.html',
  styleUrls: ['./netflix-questions.component.sass']
})
export class NetflixQuestionsComponent implements OnInit {
  public tabActive='Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token:string=sessionStorage.getItem("token");

  public content:object;
  constructor(public global:GlobalService) { }

  ngOnInit() {
    this.content={
      content:[
        {
          title:"¿Cómo puedo pagar Netflix con mi factura Claro?",
          description:"Para pagar Netflix por medio de la factura Claro, debes iniciar la suscripción al servicio de Netflix por medio de Mi Claro (app o web), pulsar la alternativa de Netflix y completar los pasos que se presentan. Claro determinará si eres elegible para este servicio. Ingresa a Mi Claro https://miclaro.clarotodo.com/ y revisa si cumples con los requisitos para suscribirte a Netflix con factura Claro.",
          expand:true
        },
        {
          title:"¿Cómo puedo pagar Netflix con mi factura Claro si ya tengo una cuenta de Netflix?",
          description:"Si ya tienes una cuenta de Netflix que pagas con otro método y deseas pagarla con la factura Claro, debes cancelar tu cuenta y esperar a que el ciclo de facturación termine en Netflix e ingresar a Mi Claro y realizar la suscripción utilizando el mismo correo electrónico y contraseña. De esta manera, podrás tener acceso al perfil e historial de tu cuenta anterior.",
          expand:false
        },
        {
          title:"¿Cómo compruebo si me están facturando por medio de mi factura Claro?",
          description:"Para comprobar si recibes la facturación del servicio de Netflix por medio de tu factura Claro, visita la sesión de Membresía y Facturación en tu cuenta de Netflix, ",
          link1:"https://www.netflix.com/YourAccount",
          link1text:"www.netflix.com/YourAccount.",
          description2:"También, puedes verificar el cargo Netflix.com en tu factura de Claro PR.",
          expand:false
        },
        {
          title:"¿Cómo cambio mi forma de pago?",
          description:"Para cambiar tu forma de pago de Netflix; de tu factura Claro a otro medio de pago debes ir directamente a la sección de Membresía y Facturación de tu cuenta en ",
          link1:"https://www.netflix.com/YourAccount",
          link1text:"www.netflix.com/YourAccount.",
          description2:"",
          expand:false
        },
        {
          title:"¿Cómo cambio mi plan de Netflix?",
          description:"Para cambiar del plan de Netflix, debes iniciar sesión en Netflix, visitar la sección Cuenta y seleccionar Cambiar plan. En esta pantalla podrás ver y seleccionar los planes disponibles.",
          expand:false
        },
        {
          title:"¿Cómo cancelo el servicio de Netflix?",
          description:"Para cancelar la membresía de Netflix, debes iniciar sesión en Netflix y visitar la sección Cuenta y seleccionar Membresía y Facturación. En esta pantalla, debes pulsar el botón Cancelar membresía.",
          expand:false
        },
        {
          title:"No recuerdo el correo electrónico que utilicé para suscribirme por medio de Factura Claro y no puedo acceder a mi cuenta.",
          description:"Si no recuerdas el correo electrónico que utilizaste para la suscripción, debes entrar a la pestaña de Netflix en Mi Claro (app o web) y pulsar el botón correspondiente para recuperarlo. Al hacerlo, se presentará la página de inicio de sesión de Netflix con la información de tu correo electrónico.",
          expand:false
        },
        {
          title:"Conecté mi cuenta de Netflix a Factura Claro, pero aun recibo cargos en mi tarjeta de débito/crédito.",
          description:"Es posible que hayas escrito mal tu email y que hayas creado una cuenta adicional, ya que esto no podría ocurrir si el cliente canceló la cuenta original con Netflix exitosamente.",
          expand:false
        },
        {
          title:"¿Qué sucede con mi cuenta de Netflix si eventualmente cambio de operador de telefonía celular?",
          description:"Si cancela su cuenta con Claro, su suscripción de Netflix podría verse afectada. Debe ponerse en contacto con Netflix a la mayor brevedad, para actualizar su método de pago y evitar la cancelación de su suscripción.",
          expand:false
        },
        {
          title:"Cómo me comunico con Servicio al Cliente de Claro?",
          description:"Puedes comunicarte con el Servicio al Cliente de Claro llamando al 787-775-0000.",
          expand:false
        }
      ]
    };

  }
  initializeData(){
    this.global.refreshDataTo(this.token);
  }
}
